import { Eye } from 'lucide-react';
import type { NlqResult } from '../engine/NlqEngine';
interface Props {
  result: NlqResult;
  onExpand: () => void;
}
export function ResultSummaryCard({
  result,
  onExpand
}: Props) {
  const results = result.results;
  if (!results) return null;
  const {
    metadata,
    rows
  } = results;
  const isAggregation = !!(result.query?.groupBy || result.query?.aggregate);
  return <div className="nlq-result-card" data-id="element-963" data-mp="1k4d8fea70nqr">
      <div className="nlq-result-header" data-id="element-964" data-mp="1k5g4e0mdhgdj">
        <span className="nlq-result-count" data-id="element-965" data-mp="1p383pfpck4rr">
          {metadata.totalRows} {isAggregation ? 'groups' : 'rows'}
        </span>
        <span className="nlq-result-dataset" data-id="element-966" data-mp="1aetp67ikirvd">
          {metadata.dataset === 'both' ? 'requests + touchpoints' : metadata.dataset}
        </span>
      </div>

      {isAggregation && rows.length > 0 && <div className="nlq-result-preview" data-id="element-967" data-mp="232pjj5ko07oz">
          {rows.slice(0, 3).map((row, i) => <div key={i} className="nlq-result-row" data-id="element-968" data-mp="27tz9y8e1ff1x" data-mpi={i}>
              {Object.entries(row).slice(0, 3).map(([key, val]) => <span key={key} className="nlq-result-cell" data-id="element-969" data-mp="1qi54zy3g8ph3">
                  <span className="nlq-result-key" data-id="element-970" data-mp="1lisi5dckviei">{key}:</span>{' '}
                  {typeof val === 'number' ? val.toLocaleString() : String(val ?? '-')}
                </span>)}
            </div>)}
          {rows.length > 3 && <span className="nlq-result-more" data-id="element-971" data-mp="1uhnkufgeyad2">+{rows.length - 3} more</span>}
        </div>}

      <button className="nlq-expand-btn" onClick={onExpand} data-id="element-972" data-mp="299xu3hfedqjj">
        <Eye size={14} data-id="element-973" data-mp="247yrwave8zo6" />
        <span data-id="element-974" data-mp="248idc1k9666y">View full results</span>
      </button>
    </div>;
}